import {
  AppHeader,
  AppHeaderBackButton,
  Box,
  Button,
  Container,
  Stack,
  Typography,
  Link,
  Progress,
  ButtonGroup,
} from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../state/state';
import { LimitReachedModal } from '../components/LimitReachedModal';
import { onDownloadPDFCard } from '../utils/getMembershipPDF';
import CAClassicCard from '../assets/membership-cards/CA/Blank_CA_Classic_Card.svg';
import CAPlusCard from '../assets/membership-cards/CA/Blank_CA_Plus_Card.svg';
import CAPremierCard from '../assets/membership-cards/CA/Blank_CA_Premier_Card.svg';
import CAClassicRVCard from '../assets/membership-cards/CA/Blank_CA_Classic_Card.svg';
import CAPlusRVCard from '../assets/membership-cards/CA/Blank_CA_Plus_RV_Card.svg';
import CAPremierRVCard from '../assets/membership-cards/CA/Blank_CA_Premier_RV_Card.svg';
import UniversalClassicCard from '../assets/membership-cards/Universal/Blank_Universal_Classic_Card.svg';
import UniversalPlusCard from '../assets/membership-cards/Universal/Blank_Universal_Plus_Card.svg';
import UniversalPremierCard from '../assets/membership-cards/Universal/Blank_Universal_Premier_Card.svg';

import { Pages } from '../utils/constants';
import { useHistory } from 'react-router-dom';
import { useLayoutEffect, useState } from 'react';
import { MembershipLevel } from '@ace-clublabs/common-membership-api-types';
import { sources } from '../api/sources';
import { isAllowedToOrder } from '../utils/rules';
import wallet from '../assets/Wallet.svg';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { yearsSinceJoinYear } from '../utils/dateHelper';

export const MembershipCard: React.FC = () => {
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);
  const [memberDetails] = useGlobalState('memberDetails');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [isTagging, setTagging] = useState(true);
  const [finishLoadingProps, setFinishLoadingProps] = useState({ finished: true, onFinish: () => {} });
  const memberId =
    memberDetails?.selectedCustomerId === '' ? memberDetails?.loggedInCustomerId : memberDetails?.selectedCustomerId;
  const member = memberDetails?.members?.find((m) => m.customerId === memberId);
  const loggedInMember = memberDetails?.members?.find((m) => m.customerId === memberDetails?.loggedInCustomerId);
  if (memberId == null || memberId == undefined || member == undefined || member == null || member?.firstName == null) {
    history.push(Pages.SorryPage);
  }
  const hideBackButton =
    memberDetails == null ||
    memberDetails?.members == null ||
    memberDetails?.members?.length == 0 ||
    memberDetails?.members?.length == 1;

  const [tags] = useGlobalState('tags');

  useLayoutEffect(() => {
    UtagHelper.sendTag(UtagType.view, tags, 'membership card', {});
    setTagging(false);
  }, []);

  if (isTagging) {
    return <></>;
  }
  const onReplacementCardRequest = async () => {
    if (!member?.plasticReplacementCard.eligible) {
      setOpenModal(true);
    } else {
      history.push(Pages.RequestPlasticCard);
    }
  };
  // precompute pdf ahead of time
  const onPDFdownloadCallback = (async () => {
    return await onDownloadPDFCard(memberDetails);
  })();
  const onPDFCardRequest = async () => {
    UtagHelper.sendTag(UtagType.link, tags, 'membership card', {
      cta: 'my account:account maintenance:replacement card:membership card-download pdf',
    });
    (await onPDFdownloadCallback)();
  };
  const clubCode: string = memberDetails.clubCode ?? '';
  const membershipLevel: string = memberDetails?.benefitLevels?.existingLevel ?? MembershipLevel.CLASSIC;
  const fullName = member?.firstName + ' ' + member?.lastName;
  const memberNumber =
    member?.membershipCardNumber?.substring(0, 3) +
    '  ' +
    member?.membershipCardNumber?.substring(3, 6) +
    '  ' +
    member?.membershipCardNumber?.substring(6, 14) +
    '  ' +
    member?.membershipCardNumber?.substring(14, 16);

  let expDate: Date | null = memberDetails?.renewexpiredate ? new Date(memberDetails?.renewexpiredate) : null;
  let expirationDate: string | null = null;

  if (expDate !== null) {
    expirationDate = expDate.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
  }

  const years = yearsSinceJoinYear(memberDetails?.joinYear ?? '').toString();

  function isEligibleIOS() {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) &&
      memberDetails.loggedInCustomerId === memberDetails.selectedCustomerId
    );
  }
  function isEligibleAndroid() {
    return /Android/.test(navigator.userAgent) && memberDetails.loggedInCustomerId === memberDetails.selectedCustomerId;
  }

  const onRequestAppleWallet = async () => {
    UtagHelper.sendTag(UtagType.link, tags, 'membership card', {
      cta: 'my account:account maintenance:replacement card:membership card-add to wallet',
    });
    setFinishLoadingProps({ finished: false, onFinish: () => {} });
    const response = await sources.getAppleWallet();
    setFinishLoadingProps({ finished: true, onFinish: () => {} });

    if (response && response.status == 'success' && response?.data) {
      try {
        const pkPass = response?.data;
        const binaryData = atob(pkPass); // Decode base64 to binary string
        const byteArray = new Uint8Array(binaryData.length);
        for (let i = 0; i < binaryData.length; i++) {
          byteArray[i] = binaryData.charCodeAt(i);
        }
        const blob = new Blob([byteArray], { type: 'application/vnd.apple.pkpass' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'Membership.pkpass';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        history.push(Pages.SorryPage);
      }
    } else {
      history.push(Pages.SorryPage);
    }
  };
  const onRequestAndroidWallet = async () => {
    UtagHelper.sendTag(UtagType.link, tags, 'membership card', {
      cta: 'my account:account maintenance:replacement card:membership card-add to wallet',
    });
    setFinishLoadingProps({ finished: false, onFinish: () => {} });
    const response = await sources.getAndroidWallet();
    setFinishLoadingProps({ finished: true, onFinish: () => {} });
    if (response && response.status == 'success' && response?.data) {
      try {
        const pkPass = response?.data;
        const binaryData = atob(pkPass); // Decode base64 to binary string
        const wallet = JSON.parse(binaryData);
        const walletUrl = wallet?.saveToWalletUrl;

        const a = document.createElement('a');
        a.href = walletUrl;
        a.target = '_blank';

        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(walletUrl);
      } catch (error) {
        history.push(Pages.SorryPage);
      }
    } else {
      history.push(Pages.SorryPage);
    }
  };

  return (
    <>
      <Container maxWidth="sm">
        <Box>
          <AppHeader
            backButton={!isMobileApp && !hideBackButton && <AppHeaderBackButton />}
            sx={{ padding: '0 !important' }}
          />
          <Stack marginTop="1rem">
            <Typography variant="h5Medium" className="membership-card-title">
              Membership card
            </Typography>
            <Typography variant="b1Regular" className="membership-card-description" marginTop="0.5rem">
              To receive Roadside Assistance, present your photo ID and digital, printed, or plastic membership card.
            </Typography>
            <Box className="membership-card-container">
              <MemberCard
                name={fullName}
                membershipNumber={memberNumber}
                years={years}
                expirationDate={expirationDate}
                clubCode={clubCode}
                membershipLevel={membershipLevel}
              />
            </Box>

            <ButtonGroup sx={{ marginTop: '1.5rem' }}>
              <Button
                visible={isEligibleAndroid}
                className="download-android-wallet-button"
                label={
                  <>
                    <img src={wallet} className="wallet-image" alt="icon" />
                    <Typography sx={{ color: '#FFF', fontWeight: '500', backgroundColor: '#000' }}>
                      {'  '}
                      Add to Google Wallet
                    </Typography>
                  </>
                }
                fullWidth
                sx={{
                  backgroundColor: '#000',
                  borderColor: '#A6A6A6',
                  ':hover': { backgroundColor: '#000' },
                }}
                onClick={onRequestAndroidWallet}
              ></Button>
              <Button
                visible={isEligibleIOS}
                className="download-apple-wallet-button"
                label={
                  <>
                    <img src={wallet} className="wallet-image" alt="icon" />
                    <Typography sx={{ color: '#FFF', fontWeight: '500', backgroundColor: '#000' }}>
                      {'  '}
                      Add to Apple Wallet
                    </Typography>
                  </>
                }
                fullWidth
                sx={{
                  backgroundColor: '#000',
                  borderColor: '#A6A6A6',
                  ':hover': { backgroundColor: '#000' },
                }}
                onClick={onRequestAppleWallet}
              ></Button>
              <Button
                className="download-pdf-button"
                label="Download PDF"
                variant="outlined"
                fullWidth
                onClick={onPDFCardRequest}
              />
            </ButtonGroup>
            {isAllowedToOrder(memberDetails?.clubCode, loggedInMember?.roleType) ? (
              <Link
                variant="b2Regular"
                sx={{
                  color: '#0156A3',
                  marginTop: '1rem',
                  cursor: 'pointer',
                  marginBottom: '2rem',
                  alignSelf: 'center',
                }}
                className="request-plastic-card-link"
                onClick={onReplacementCardRequest}
              >
                Request a plastic replacement card
              </Link>
            ) : (
              <></>
            )}
          </Stack>
        </Box>
        {!finishLoadingProps.finished && <Progress variant="circular" />}
      </Container>
      <LimitReachedModal open={openModal} onClose={() => setOpenModal(false)}></LimitReachedModal>
    </>
  );
};

interface MembershipCardSVGProps {
  name: string;
  membershipNumber: string;
  years: string;
  expirationDate: string | null;
  clubCode: string;
  membershipLevel: string;
}

const svgMap: (clubCode: string) => Record<string, string> = (clubCode: string) => {
  switch (clubCode) {
    case '004':
      return {
        CLASSIC: CAClassicCard,
        PLUS: CAPlusCard,
        PREMIER: CAPremierCard,
        CLRV: CAClassicRVCard,
        PLRV: CAPlusRVCard,
        PRRV: CAPremierRVCard,
      };
    default:
      return {
        CLASSIC: UniversalClassicCard,
        PLUS: UniversalPlusCard,
        PREMIER: UniversalPremierCard,
        CLRV: UniversalClassicCard,
        PLRV: UniversalPlusCard,
        PRRV: UniversalPremierCard,
      };
  }
};

const MemberCard: React.FC<MembershipCardSVGProps> = ({
  name,
  membershipNumber,
  years,
  expirationDate,
  clubCode,
  membershipLevel,
}) => {
  return (
    <div style={{ width: '100%', height: '100%' }} className="membership-card-image">
      <svg width="100%" height="100%" viewBox="0 0 400 200" xmlns="http://www.w3.org/2000/svg">
        <image href={svgMap(clubCode)[membershipLevel]} x="0" y="0" width="400" height="200" />
        <text x="57" y="116" fontSize="12" data-qm-block="true">
          {name}
        </text>
        <text x="57" y="135" fontSize="12" style={{ whiteSpace: 'pre' }} data-qm-block="true">
          {membershipNumber}
        </text>
        <text x="199" y="187" fontSize="20" fill="#FF0000" textAnchor="end">
          {years}
        </text>
        <text x="58" y="185" fontSize="12">
          {expirationDate}
        </text>
      </svg>
    </div>
  );
};
